import { resetLayerSelection, selectLayer } from '../InteractiveMap/utils/projectLayers';

class ProjectCard {
  async init() {
    await this.handleCardListUpdates();
  }

  async handleCardListUpdates() {
    const cardList = document.querySelector('#js-org-interactive-map-projects-list');

    const observer = await new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          this.updateCardLengthCount();
        } else if (mutation.type === 'attributes') {
          this.updateCardLengthCount();
        }
      }
    });

    observer.observe(cardList, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }

  updateCardLengthCount() {
    const resultsCountInfo = document.getElementById('js-org-interactive-map-count-results');
    const resultsNoCountInfo = document.getElementById('js-org-interactive-map-count-results-none');
    const cardItems = document.querySelectorAll('.mol--project-card.is-visible');

    if (cardItems.length === 0) {
      resultsNoCountInfo.style.display = 'inline-block';
      resultsCountInfo.style.display = 'none';
    }

    if (cardItems.length > 0) {
      resultsCountInfo.innerHTML = `${cardItems.length}`;
      resultsCountInfo.style.display = 'inline-block';
      resultsNoCountInfo.style.display = 'none';
    }
  }
}

export default ProjectCard;

export function handleCardEvents(card, cardsWrapper, map, view) {
  const isActive = card.classList.toggle('is-active');

  if (isActive) {
    selectLayer(card.dataset.id, map, view);
  } else {
    resetLayerSelection(map, view);
  }

  document.addEventListener('click', (event) => {
    if (!card.contains(event.target)) {
      card.classList.remove('is-active');
    }

    if (!cardsWrapper.contains(event.target)) {
      resetLayerSelection(map, view);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === ' ') {
      if (!card.contains(event.target)) {
        card.classList.remove('is-active');
      }

      if (!cardsWrapper.contains(event.target)) {
        resetLayerSelection(map);
      }
    }
  });
}

export async function buildCardsFromLayers(map, view) {
  const cardsWrapper = document.getElementById('js-org-interactive-map-projects-list');
  const cardTemplate = document.getElementById('js-project-card-template');
  const cardAttributesTemplate = document.getElementById('js-project-card-attribute-template');
  const cardsCmsDataString = cardsWrapper.dataset.cardsCmsData;
  const cardsCmsData = JSON.parse(cardsCmsDataString);

  for (const mapLayer of await map.layers.toArray()) {

    const mapLayerIsInFirstspiritDataset = cardsCmsData.find(items => items.id === mapLayer.id);

    if (mapLayerIsInFirstspiritDataset && mapLayer.type === 'group') {
      const cardClone = cardTemplate.content.cloneNode(true);
      const card = cardClone.querySelector('.js-mol-project-card');
      const cardAttributesList = cardClone.querySelector('.js-mol-project-card-card-attribute-list');
      const title = cardClone.querySelector('.js-mol-project-card-title');
      const button = cardClone.querySelector('.js-mol-project-card-button');
      let suitableAttributes;

      // build attributes and card filter data
      card.dataset.id = mapLayer.id;
      card.dataset.filterName = mapLayer.title;

      if (cardsCmsData) {
        suitableAttributes = cardsCmsData.find(items => items.id === card.dataset.id);
      }

      if (suitableAttributes && suitableAttributes.attributes) {
        title.innerText = suitableAttributes.title;

        suitableAttributes.attributes.forEach((attribute) => {
          const cardAttributesClone = cardAttributesTemplate.content.cloneNode(true);
          const attributeListElement = cardAttributesClone.querySelector('.js-mol-project-card-attribute');
          const attributeLabel = attributeListElement.querySelector('.js-mol-project-card-attribute-label');
          const attributeValue = attributeListElement.querySelector('.js-mol-project-card-attribute-value');
          attributeLabel.innerText = attribute.label;
          attributeValue.innerHTML = attribute.value;
          cardAttributesList.appendChild(cardAttributesClone);

          switch (true) {
            case attribute.key && attribute.key.toString() === 'type':
              card.dataset.filterProjectType = attribute.value;
              break;
            case attribute.key && attribute.key.toString() === 'status':
              card.dataset.filterProjectStatus = attribute.value;
              break;
            case attribute.key && attribute.key.toString() === 'projectStart':
              card.dataset.filterProjectStart = attribute.value;
              break;
            case attribute.key && attribute.key.toString() === 'IBN':
              card.dataset.filterProjectEnd = attribute.value;
              break;
            default:
              break;
          }
        });

        const label = suitableAttributes.label ? suitableAttributes.label : `Details page ${mapLayer.title}`;
        button.href = suitableAttributes.href;
        button.setAttribute('aria-label', label);
      }

      card.classList.add('is-visible');

      /**
       * Adjust handlers
       */
      card.addEventListener('click', () => handleCardEvents(card, cardsWrapper, map, view));
      card.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          handleCardEvents(card, cardsWrapper, map, view);
        }
      });

      cardsWrapper.appendChild(cardClone);
    }
  }
}

export function updateVisibleCards(results = {}) {
  const cardsWrapper = document.getElementById('js-org-interactive-map-projects-list');
  const cards = cardsWrapper.querySelectorAll('.mol--project-card');


  cards.forEach((card) => {
    /* eslint-disable no-console */
    const id = card.dataset.id;
    const result = results.find(element => element.id === id);

    if (result && result.visible) {
      card.classList.add('is-visible');
    } else {
      card.classList.remove('is-visible');
    }
  });
}
